import {
  dispatchNotificationsChanged,
  fetchLevelHistory,
  recordDailyQuestCompleteHistory,
} from "./levelHistoryApi";
import { fetchTodayQuests, markQuestHistoryRecorded } from "./questApi";

const recordedQuestDates = new Set();
let syncChain = Promise.resolve();

export function isQuestFullyCompleted(payload) {
  const objectives = payload?.objectives;
  if (!Array.isArray(objectives) || objectives.length === 0) {
    return false;
  }

  return objectives.every((objective) => objective.status === "completed");
}

async function dailyQuestHistoryExists(questDate) {
  if (!questDate) return false;

  const { entries } = await fetchLevelHistory();
  return (entries || []).some(
    (entry) => entry?.type === "daily_quest" && entry?.questDate === questDate
  );
}

async function resolveQuestPayload(payload) {
  if (payload?.objectives?.length) {
    return payload;
  }

  try {
    const quests = await fetchTodayQuests();
    return quests?.found ? quests : null;
  } catch {
    return null;
  }
}

async function syncDailyQuestHistoryUnqueued(payload) {
  const questPayload = await resolveQuestPayload(payload);
  const questDate = questPayload?.date;

  if (!questDate || !isQuestFullyCompleted(questPayload)) {
    return false;
  }

  if (recordedQuestDates.has(questDate)) {
    return false;
  }

  try {
    if (await dailyQuestHistoryExists(questDate)) {
      recordedQuestDates.add(questDate);
      try {
        await markQuestHistoryRecorded();
      } catch {
        // Le VPS peut ne pas encore exposer cette route.
      }
      return false;
    }
  } catch (err) {
    console.warn("Quête complète — vérification historique :", err.message);
  }

  try {
    await recordDailyQuestCompleteHistory(questDate);
    recordedQuestDates.add(questDate);

    try {
      await markQuestHistoryRecorded();
    } catch (err) {
      console.warn("Quête complète — confirmation VPS :", err.message);
    }

    dispatchNotificationsChanged();
    return true;
  } catch (err) {
    console.error("Quête complète — échec enregistrement historique :", err.message);
    return false;
  }
}

export function syncDailyQuestHistoryIfNeeded(payload) {
  const run = syncChain.then(
    () => syncDailyQuestHistoryUnqueued(payload),
    () => syncDailyQuestHistoryUnqueued(payload)
  );
  syncChain = run.then(
    () => undefined,
    () => undefined
  );
  return run;
}

export async function processQuestCompletionSideEffects(payload) {
  return syncDailyQuestHistoryIfNeeded(payload);
}
